import _regeneratorRuntime from "/home/vsts/work/1/s/Code/WebApp/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/home/vsts/work/1/s/Code/WebApp/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/Code/WebApp/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
import * as tslib_1 from "tslib";
/**
 * @class
 * @implements Middleware
 * Class for HTTPMessageHandler
 */

export var HTTPMessageHandler =
/*#__PURE__*/
function () {
  function HTTPMessageHandler() {
    _classCallCheck(this, HTTPMessageHandler);
  }

  _createClass(HTTPMessageHandler, [{
    key: "execute",

    /**
     * @public
     * @async
     * To execute the current middleware
     * @param {Context} context - The request context object
     * @returns A promise that resolves to nothing
     */
    value: function execute(context) {
      return tslib_1.__awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetch(context.request, context.options);

              case 3:
                context.response = _context.sent;
                return _context.abrupt("return");

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                throw _context.t0;

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));
    }
  }]);

  return HTTPMessageHandler;
}();